import { StorageService } from '@wlp/ui-bs-oauth';
import { Router } from '@angular/router';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';

import { UICMenuAppService } from '@wlp/ui-c-menu-app';
import { LoadingService } from 'src/app/core/layout/services/loading.service';
import { FormGroup } from '@angular/forms';
import { NavController, ModalController } from '@ionic/angular';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { Component, OnInit } from '@angular/core';
import { ConsultDetranService, CreateVehicleDetranService } from '@wlp/ui-bs-detran';
import { ModalAlertComponent } from 'src/app/views/themes/sentinel/modals/modal-alert/modal-alert.component';
import { UserInfoService } from '@wlp/ui-bs-login';

@Component({
  selector: 'app-car-list',
  templateUrl: './car-list.component.html',
  styleUrls: ['./car-list.component.scss']
})
export class CarListComponent implements OnInit {

  iconName: string | 'eye-off-outline' | 'eye-outline';
  balanceTitle: string;
  titleHeader: string;
  backgroundHeaderLogon: any;

  listCars: any[];
  userProfile: any;
  createVehicleForm: any;
  listStates: any[];
  errosMessages: any;

  constructor(
    private layoutConfigService: LayoutConfigService,
    private navController: NavController,
    private consultDetranService: ConsultDetranService,
    private load: LoadingService,
    private modalController: ModalController,
    private menuService: UICMenuAppService,
    private userInfoService: UserInfoService,
    private translate: UiBsTranslateService,
    private createVehicleDetranService: CreateVehicleDetranService,
    private router: Router,
    private storageService: StorageService
  ) { }

  ngOnInit() {
    this.iconName = 'eye-off-outline';
    this.titleHeader = 'CASH_OUT.BILLET.HEADER.TITLE';
    this.balanceTitle = 'CASH_OUT.BILLET.HEADER.SUBTITLE';
    this.backgroundHeaderLogon = this.layoutConfigService.getConfig('wlTheme.header.background.image');
    this.menuService.applyStatus(false);
    
    this.createVehicleForm = this.createVehicleDetranService.createForm();
    this.errosMessages = this.createVehicleDetranService.getErrosMessages();
    
    this.listStates = new Array();
    this.getStates()

    this.loadUser()
  }


  vehicleSelected(vehicle: any) {
    this.storageService.set('uuidVehicle', vehicle.uuid).then(res => {
      this.router.navigate(['app/payment/detran/consult'], { state: { vehicle } })
    })
  }


  continue() {
    this.navController.navigateRoot(['/app/payment/detran/management-car']);
  }


  dismiss() {
    this.navController.navigateRoot(['app/dashboard']);
  }

  private async notification(status: string, message: string, confirmation?: boolean) {
    const modalSuccess = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status,
        message,
        confirmBtn: 'OK',
        cancelBtn: 'Cancelar',
        confirmation,
        translate: true,
      },
      backdropDismiss: false,
    });

    await modalSuccess.present();
    return await modalSuccess.onWillDismiss();
  }


  getListVehicles() {
    this.load.show();
    this.consultDetranService.getListVehicles(this.userProfile.uuidAccount, this.userProfile.uuidWhiteLabel)
      .subscribe(res => {
        if (res.statusCode === 400) {
          this.load.hide();
          this.notification('warning-circle', res.message, false);
        } else {
          this.load.hide()
          this.listCars = res;
        }
      }, (err) => {
        this.listCars = [];
        this.load.hide();
        this.notification('warning-circle', this.translate.applyTranslate('CASH_OUT.DETRAN.MESSAGES.FAILED_DEFAULT'), false);
      })
  }

  private loadUser() {
    try {
      const userDetails = this.userInfoService.getInfoProfile();

      userDetails.then((user) => {
        this.userProfile = user;
        this.getListVehicles();
      });

    } catch (e) {
      console.log('Failed to load user details', e);
    }
  };

  emitVehicleDelete(vehicle) {    
    this.notification('warning-circle', `Deseja remover: ${vehicle.description}`, true).then(res => {      
      if (res.data) {
        this.load.show();
        this.createVehicleDetranService.deleteVehicle(vehicle.uuid)
          .subscribe(res => {
            if (res.statusCode === 400) {
              this.load.hide();
              this.notification('warning-circle', res.message, false);
            } else {
              this.load.hide()
              this.getListVehicles();
            }
          }, (err) => {
            this.load.hide();
            this.notification('warning-circle', this.translate.applyTranslate('CASH_OUT.DETRAN.MESSAGES.FAILED_DEFAULT'), false);
          })
      };
    })    
  }

  getStates() {
    this.consultDetranService.getStates()
      .subscribe(res => {
        if (res.statusCode === 400) {
          this.load.hide();
          this.notification('warning-circle', res.message, false);
        } else {
          this.load.hide()
          this.listStates = res;
        }
      }, (err) => {
        this.load.hide();
        this.notification('warning-circle', this.translate.applyTranslate('CASH_OUT.DETRAN.MESSAGES.FAILED_DEFAULT'), false);
      })
  }


  createVehicle() {
    this.load.show();
    this.createVehicleDetranService.createVehicle(
      this.createVehicleForm.getRawValue(),
      this.userProfile.uuidAccount,
      this.userProfile.uuidWhiteLabel,
    ).subscribe(res => {
      if (res.statusCode === 400) {
        this.load.hide();
        this.notification('warning-circle', res.message, false);
      } else {
        this.load.hide();
        this.getListVehicles()
        this.navController.navigateRoot(['app/payment/detran/vehicle-list']);
      }
    }, (err) => {
      this.load.hide();
      this.notification('warning-circle', this.translate.applyTranslate('CASH_OUT.DETRAN.MESSAGES.FAILED_DEFAULT'), false);
    })
  }

}
